const ValueCard = ({ iconSrc, label, title, description }) => {
  return (
    <div>
      <div className="flex flex-col items-start mb-3">
        <div className="flex mb-5 items-center justify-center mr-3 w-full xl:w-fit">
          <div className="w-12 h-12 flex items-center justify-center bg-[#EE005B] rounded-full p-3">
            <img
              src={iconSrc}
              alt={`${label} icon`}
              className="w-full h-full object-contain"
            />
          </div>
        </div>
        <span className="text-sm inline-block w-full xl:w-fit font-medium uppercase tracking-wider text-gray-700 dark:text-zinc-400">
          {label}
        </span>
      </div>
      <h2 className="text-2xl font-bold text-gray-900 mb-2 leading-tight dark:text-zinc-200">
        {title}
      </h2>
      <p className="text-md text-gray-700 leading-relaxed dark:text-zinc-400">
        {description}
      </p>
    </div>
  );
};

const valueData = [
  {
    iconSrc: "/new-final-data/about/Highlight.png",
    label: "MISSION",
    title: "Helping others companies to be highlighted",
    description:
      "Digicots gives a very important value to those who seek to go out of the ordinary, only in this way, it is possible to stand out.",
  },
  {
    iconSrc: "/new-final-data/about/leading.png",
    label: "VISION",
    title: "To be a leading creative web agency",
    description:
      "We work every day to increase our knowledge to be pioneers in technology and creativity.",
  },
  {
    iconSrc: "/new-final-data/about/time.png",
    label: "VALUES",
    title: "We are defined by our track record.",
    description: "Transparency and professionalism above all.",
  },
  {
    iconSrc: "/new-final-data/about/Help.png",
    label: "COMMITMENT",
    title: "Always offer help unselfishly",
    description:
      "As well as being an agency, we are human and are happy to help wherever we can.",
  },
];

const AboutSection2 = () => {
  return (
    <div className="py-20 xl:px-35 px-10 mx-auto grid grid-cols-1 md:grid-cols-2 gap-16 font-sans bg-gray-50 dark:bg-zinc-900 dark:text-white">
      {/* Left Section */}
      <div>
        <div className="uppercase text-sm font-semibold  text-gray-800 dark:text-zinc-400 mb-3">
          DIGICOTS AGENCY
        </div>
        <h1 className="text-4xl font-semibold text-gray-900 dark:text-zinc-200 mb-5">
          We help to develop and create <br /> strategies with creative designs.
        </h1>
        <p className="text-md text-gray-700 dark:text-zinc-400 leading-relaxed max-w-lg mb-6">
          Digicots is a digital marketing agency specialising in web design and
          development. For over 15 years we have been providing solutions to
          small, medium and large companies looking to take a step further in
          their goal of constantly improving day after day.
        </p>

        {/* Image placeholder - replace with your actual image */}
        <div className="overflow-hidden">
          <img
            src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1471&q=80"
            alt="Digicots working at computer"
            className="xl:w-[90%] h-[35vh] object-cover"
          />
        </div>
      </div>

      {/* Right Section - Modular 2x2 Grid */}
      <div className="grid xl:grid-cols-2 gap-8 mt-8 md:mt-0">
        {valueData.map((item, index) => (
          <ValueCard
            key={index}
            iconSrc={item.iconSrc}
            label={item.label}
            title={item.title}
            description={item.description}
          />
        ))}
      </div>
    </div>
  );
};

export default AboutSection2;
